/**
 * 지정한 URL을 비율에 맞춘 크기의 팝업 창으로 엽니다.
 * @description
 * - `window.open`으로 전달받은 URL을 새 팝업 창에 그대로 로드하는 범용 함수입니다.
 *   (특정 페이지/컴포넌트를 렌더링하지 않고, url 자체를 새 창에 띄웁니다.)
 * - 콘텐츠 뷰어('/contents')를 여는 용도가 아니라, 외부/전체 URL을 팝업으로 띄울 때 사용합니다.
 *   콘텐츠 뷰어가 필요하면 utils/openContentsWindow 의 openContentsWindow 계열을 사용하세요.
 * - 현재는 주로 AI인증제(응시/결과) 창을 여는 데 사용됩니다.
 * @param url 팝업에 로드할 URL(full URL)
 * @param width 원하는 창 가로 크기(px). 화면보다 크면 화면 크기로 제한됩니다.
 * @param ratio 가로/세로 비율(width / height). 세로는 width / ratio 로 계산됩니다.
 * @returns 열린 창의 참조(Window) 또는 차단 시 null
 */
const openPopupWindow = (url: string, width: number, ratio: number) => {
  // 스크린 사이즈
  const screenWidth = window.screen.width;

  // 스크린보다 클 경우 스크린 사이즈로 제한
  const newWidth = width > screenWidth ? screenWidth : width;
  // 가로가 변경된 경우 세로도 비율에 맞춰 변경
  const newHeight = newWidth / ratio;

  const newWindow = window.open(
    url,
    'PopupWindow',
    `location=no, menubar=no,width=${newWidth},height=${newHeight}`,
  );
  return newWindow;
};

/**
 * AI인증제 링크를 실제 오픈할 URL로 변환합니다.
 * @description 로컬 개발 서버(NODE_ENV=development)에서 REACT_APP_JEBS_RECITATION_URL이 설정된 경우에만
 * 호스트를 로컬 주소로 교체합니다. 그 외에는 서버가 내려준 링크를 그대로 사용합니다.
 * @param link AI인증제 링크(full URL)
 * @returns 오픈에 사용할 URL
 */
export const resolveRecitationUrl = (link: string): string => {
  const localUrl = process.env.REACT_APP_JEBS_RECITATION_URL;
  if (process.env.NODE_ENV !== 'development' || !localUrl) return link;

  const { pathname, search } = new URL(link);
  return `${localUrl.replace(/\/$/, '')}${pathname}${search}`;
};

export default openPopupWindow;
